
// This file connects to the appropriate Supabase project based on the environment
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getConfig } from '@/config/environment';

// Get configuration based on current environment
const config = getConfig();

// Use the config to determine which Supabase project to connect to
const SUPABASE_URL = config.supabaseUrl;
const SUPABASE_PUBLISHABLE_KEY = config.supabaseKey;

// Log the environment in development/staging for debugging
if (config.debugMode) {
  console.log(`Connecting to Supabase at ${SUPABASE_URL}`);
  console.log(`Environment: ${import.meta.env.MODE}`);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create and export the Supabase client with storage capabilities enabled
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'x-application-name': 'freelance-with-andy',
      },
    },
  }
);
